import type { GameDto } from '@/queries/games/games.schema';
import { isEmpty } from '@/utils/objects.utils';

export const detailsNameMap: { [key: string]: string } = {
  releaseDate: 'Release date',
  reels: 'Reels',
  paylines: 'Paylines',
  volatility: 'Volatility',
  rtp: 'RTP',
  minBet: 'Min bet',
  maxBet: 'Max bet',
  freeSpins: 'Free Spins',
  bonusRound: 'Bonus Round',
  autoplay: 'Autoplay',
  multiplayer: 'Multiplayer',
  wild: 'Wild',
  scatter: 'Scatter',
  software: 'Software',
  totalMaxWin: 'Total max win',
  themes: 'Themes',
  features: 'Features',
  slotype: 'Slot type',
};
type Block
  = | { type: 'text'; content: string }
    | { type: 'link'; content: { text: string; url: string } };

export function parseBlocksValue(value: string): Block[] {
  try {
    const parsed = JSON.parse(value);

    if (
      Array.isArray(parsed)
      && parsed.every(
        b =>
          (b.type === 'text' && typeof b.content === 'string')
          || (b.type === 'link'
            && b.content
            && typeof b.content.text === 'string'
            && typeof b.content.url === 'string'),
      )
    ) {
      return parsed;
    }
    return [{ type: 'text', content: value }];
  } catch (e) {
    console.warn('parseBlocksValue error:', e, value);
    return [{ type: 'text', content: value }];
  }
}

const escapeHtml = (unsafe: string) =>
  unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

export const generateBlocksHTML = (blocks: Block[]) => {
  const res = blocks
    .map(b =>
      b.type === 'text'
        ? escapeHtml(b.content)
        : `<a href="${escapeHtml(b.content.url)}" target="_blank" rel="noopener noreferrer" class="hover:underline text-light" contenteditable="false">${escapeHtml(b.content.text)}</a>`,
    )
    .join('');

  return res;
};

export const GameTabsMap = {
  gallery: {
    id: 'game-gallery',
    title: 'game-details.gallery',
  },
  details: {
    id: 'game-details',
    title: 'game-details.game-details',
  },
  about: {
    id: 'game-about',
    title: 'game-details.about-game',
  },
  compare: {
    id: 'game-compare',
    title: 'game-details.compare',
  },
  rating: {
    id: 'game-rating',
    title: 'game-details.rating',
  },
} as const;

export const getAvailableGameTabs = (game: GameDto | null | undefined) => {
  const t: { id: string; title: string }[] = [];
  const hasNoEmptyKeys = game?.details && Object.values(game?.details).some(value => !!value);

  if (!game) {
    return [];
  }

  if (!isEmpty(game.assets)) {
    t.push(GameTabsMap.gallery);
  }

  if (hasNoEmptyKeys) {
    t.push(GameTabsMap.details);
  }

  const emptyAbout = isEmpty(game?.pageContent?.body) || (game?.pageContent?.body && game.pageContent.body.length <= 2);

  if (!emptyAbout) {
    t.push(GameTabsMap.about);
  }

  // TODO: add rest of tabs later - compare
  return t;
};
